// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoaderIcon_loader__1QRw0","rotation":"LoaderIcon_rotation__-UhII"};